import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Grid from '../components/Grid'
import UbliqueRow from '../components/Row'
import UbliqueColumn from '../components/Column'
import StripePageTitle from '../components/StripePageTitle'
import UbliqueContainer from '../components/Container'

import './index.scss'

const PageCustom = ({ title, className, children, configMenu }) => {
  return (
    <UbliqueContainer>
      <Grid className={cn('ublique-page', className)}>
        {title && <StripePageTitle text={title} configMenu={configMenu} />}
        {children}
      </Grid>
    </UbliqueContainer>
  )
}

PageCustom.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.array,
  configMenu: PropTypes.object
}

PageCustom.defaultProps = {
  title: ''
}

export { UbliqueRow, UbliqueColumn, PageCustom as default }
